import React from 'react';
import { Flex } from 'antd';
import { DisplayTimeSelection } from '@/pages/Shipments/MapExternalView/types';
import LogiblocksDateCalendar from './LogiblocksDateCalendar';
import SelectedEntriesHeader from './SelectedEntriesHeader';
import EntryChipList from './EntryChipList';
import { DateWindowEntry } from './dateSetTypes';
import { dateChipConfig, newDateEntry } from './dateSetUtils';

interface SpecificDatesEditorProps {
  entries: DateWindowEntry[];
  onChange: (entries: DateWindowEntry[]) => void;
  timezoneValue: DisplayTimeSelection;
  onTimezoneChange: (sel: DisplayTimeSelection) => void;
  disabled?: boolean;
}

/** The Specific date(s) tab body: calendar, "Selected dates" header with the
 * timezone selector, and the date chips. */
const SpecificDatesEditor: React.FC<SpecificDatesEditorProps> = ({
  entries,
  onChange,
  timezoneValue,
  onTimezoneChange,
  disabled = false,
}) => {
  const toggleDate = (isoDate: string) => {
    const exists = entries.some((e) => e.date === isoDate);
    onChange(
      exists
        ? entries.filter((e) => e.date !== isoDate)
        : [...entries, newDateEntry(isoDate)]
    );
  };

  return (
    <Flex vertical gap={12}>
      <LogiblocksDateCalendar
        values={entries.map((e) => e.date)}
        onToggleDate={toggleDate}
      />
      <SelectedEntriesHeader
        kind='dates'
        count={entries.length}
        timezoneValue={timezoneValue}
        onTimezoneChange={onTimezoneChange}
      />
      <EntryChipList
        entries={entries}
        {...dateChipConfig}
        onChange={onChange}
        disabled={disabled}
      />
    </Flex>
  );
};

export default SpecificDatesEditor;
